export default __webpack_public_path__ + "static/media/icon-empty.01fb2a91.svg";